<template>
  <f7-fab
    v-if="routePath"
    color="white"
    position="left-top"
    @click="click">
    <FlatIcon
      name="route-active"
      :size="32" />
  </f7-fab>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'RouteButton',
  computed: {
    ...mapGetters({
      routePath: 'global/routePath'
    })
  },
  methods: {
    click () {
      this.$f7.views.main.router.navigate('/route')
      this.$emit('click')
    }
  }
}
</script>
